import dayjs from 'dayjs';
import { makeAutoObservable } from 'mobx';
import { ThemeType } from 'styleguide/theme';
import API from 'utils/API';

const SERVER_STORAGE_LOCAL_STORAGE_KEY = 'SERVER_STORAGE_LOCAL_STORAGE_KEY';
const HEVY_WEB_THEME_PREFERENCE_KEY = 'HEVY_WEB_THEME_PREFERENCE';
const STORAGE_UPDATED_AT_KEY = `UPDATED_AT`;

export class ServerStorage {
  private _serverStorage: Record<string, any> = {};

  constructor() {
    makeAutoObservable(this);
  }

  hydrate = () => {
    const jsonData = window.localStorage.getItem(SERVER_STORAGE_LOCAL_STORAGE_KEY);

    if (jsonData) {
      this._serverStorage = Object.assign({}, JSON.parse(jsonData));
    }
  };

  clearData = () => {
    this._serverStorage = {};
    window.localStorage.removeItem(SERVER_STORAGE_LOCAL_STORAGE_KEY);
  };

  get disableSuggestedUsers() {
    return this._serverStorage['DisableSuggestedUsers'] ?? false;
  }

  setHevyWebThemePreference = async (themeKey: ThemeType) => {
    this._serverStorage[HEVY_WEB_THEME_PREFERENCE_KEY] = themeKey;
    await this.push();
  };

  get hevyWebThemePreference(): ThemeType | undefined {
    return this._serverStorage[HEVY_WEB_THEME_PREFERENCE_KEY];
  }

  private push = async () => {
    this._serverStorage[STORAGE_UPDATED_AT_KEY] = dayjs().toISOString();

    await API.updateUserKeyValues(this._serverStorage);
  };

  fetch = async () => {
    const result = await API.getUserKeyValues();
    this._serverStorage = result.data;
    window.localStorage.setItem(
      SERVER_STORAGE_LOCAL_STORAGE_KEY,
      JSON.stringify(this._serverStorage),
    );
  };
}
